import uiConfig from '@/config/ui-config'

const title = uiConfig.title

export default function getPageTitle(pageTitle) {
  if (pageTitle) {
    return `${pageTitle} - ${title}`
  }
  return `${title}`
}
